import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { AppConfig } from '../../../app.config';
import * as moment from 'moment';

const safeDrivingStatusEnum = {
  'expired' : 'expired',
  'expiring' : 'expiring',
  'current' : 'current'
};

@Injectable()
export class SafeDrivingService {

  constructor(private authHttp: AuthHttp, private appConfig: AppConfig) { }

  getSafeDrivingExpiry() {
    const serverUrl = this.appConfig.getValue('endPoint');
    return this.authHttp.get(serverUrl + 'templatedrivenwidget/safedriving').toPromise().then(response => {
      return response.text();
    });
  }

  removeSafeDrivingExpiry() {
    const serverUrl = this.appConfig.getValue('endPoint');
    return this.authHttp.put(serverUrl + 'templatedrivenwidget/removesafedriving', {}).toPromise().then(response => {
      return response.text();
    });
  }

  safeDriveStatus(safeDriveExpireDate) {
      const expiryDate = moment(safeDriveExpireDate);

      let status = '';
      if (expiryDate.isSameOrBefore(moment())) {
        status = safeDrivingStatusEnum.expired;
      }

      if (expiryDate.isAfter(moment())) {
        status = safeDrivingStatusEnum.expiring;
      }

      if (expiryDate.isAfter(moment().add(6, 'weeks'))) {
        status = safeDrivingStatusEnum.current;
      }

      return status;
  }
}



// WEBPACK FOOTER //
// ./app/widgets/templateDrivenWidget/services/safe-driving.service.ts